const VALID_ENVS = ["local", "staging", "prod", "production", "sandbox", "demo"] as const;
type Env = (typeof VALID_ENVS)[number];

const isVitest = typeof import.meta.env.VITEST !== "undefined";

const requireString = (key: string, value: string | undefined): string => {
  if (!value) throw new Error(`Missing required env var: ${key}`);
  return value;
};

const raw = isVitest
  ? {
    VITE_ENV: "local",
    VITE_FASTAPI_URL: "http://localhost:8000",
    VITE_CLERK_PUBLISHABLE_KEY: "mock_clerk_key",
    VITE_BUILD_ID: "test",
    VITE_BUILD_DATE: "2020-01-01T00:00:00Z",
    VITE_PUBLIC_POSTHOG_KEY: "mock_posthog_key",
    VITE_PUBLIC_POSTHOG_HOST: "https://us.i.posthog.com",
    VITE_TRACE_URL_TEMPLATE: "http://localhost:6006/projects/AAAAAAAAAAAAAA==/spans/{trace_id}",
  }
  : import.meta.env;

const ENV = (() => {
  const val = raw.VITE_ENV;
  if (!VALID_ENVS.includes(val as Env)) {
    throw new Error(`Invalid ENV: "${val}". Must be one of: ${VALID_ENVS.join(", ")}`);
  }
  return val as Env;
})();

const BUILD_DATE = (() => {
  const val = requireString("BUILD_DATE", raw.VITE_BUILD_DATE);
  const date = new Date(val);
  if (isNaN(date.getTime())) throw new Error(`Invalid BUILD_DATE: "${val}"`);
  return date;
})();

export const envVars = {
  ENV,
  EFFECTIVE_ENV: ENV === "local" ? ("sandbox" as const) : ENV,
  FASTAPI_URL: requireString("FASTAPI_URL", raw.VITE_FASTAPI_URL),
  CLERK_PUBLISHABLE_KEY: requireString("CLERK_PUBLISHABLE_KEY", raw.VITE_CLERK_PUBLISHABLE_KEY),
  BUILD_ID: requireString("BUILD_ID", raw.VITE_BUILD_ID),
  BUILD_DATE,
  PUBLIC_POSTHOG_KEY: requireString("PUBLIC_POSTHOG_KEY", raw.VITE_PUBLIC_POSTHOG_KEY),
  PUBLIC_POSTHOG_HOST: requireString("PUBLIC_POSTHOG_HOST", raw.VITE_PUBLIC_POSTHOG_HOST),
  TRACE_URL_TEMPLATE: raw.VITE_TRACE_URL_TEMPLATE as string | undefined,
} as const;
